import React, { ReactNode } from 'react';
import parse from 'html-react-parser';
import { IDisclosure } from '../../interfaces';

type DisclosureWithSymbolProps = {
  className?: string;
  symbol?: string;
  disclosure: IDisclosure;
  toSuperscriptSymbol?: boolean;
  smallSymbol?: boolean;
  id?: string;
  disclosureLink?: string;
};

export class DisclosureWithSymbol extends React.Component<DisclosureWithSymbolProps> {
  render() {
    const { className, symbol, disclosure, toSuperscriptSymbol, id } = this.props;
    const cl = className ? `${className} ` : '';
    const actualSymbol = symbol ?? disclosure.symbol ?? '';
    const returnSymbol = (s: string) => {
      if (!s) return '';
      const shouldSuperscript =
        toSuperscriptSymbol === true ? true : toSuperscriptSymbol === false ? false : s !== '*'; // default: do not superscript * only

      return shouldSuperscript ? `<sup>${s}</sup>` : s;
    };

    return (
      <p
        id={id || disclosure.id}
        {...(cl ? { className: cl.trim() } : {})}>
        {parse(`${returnSymbol(actualSymbol)}`)}
        {typeof disclosure.copy === 'string' ? parse(disclosure.copy) : disclosure.copy}
      </p>
    );
  }
}
export class DisclosureSymbolLink extends React.Component<DisclosureWithSymbolProps> {
  render() {
    const { className, symbol, disclosure, toSuperscriptSymbol, smallSymbol, id, disclosureLink } =
      this.props;
    const cl = className ? `${className} ` : '';
    const returnSymbol = (s: string) => {
      const shouldSuperscript =
        toSuperscriptSymbol === true ? true : toSuperscriptSymbol === false ? false : s !== '*'; // default: do not superscript *

      return shouldSuperscript ? (
        <sup {...(smallSymbol ? { className: 'small' } : {})}>{s}</sup>
      ) : (
        s
      );
    };
    const ariaProps = id !== '' ? { 'aria-describedby': id || disclosure.id } : {};
    return (
      <a
        {...{ className: `disclosure-symbol ${cl}`.trim() }}
        href={disclosureLink || `#${id || disclosure.id}`}
        {...ariaProps}
        aria-label="See disclosure details.">
        {returnSymbol(symbol || disclosure.symbol || '')}
      </a>
    );
  }
}
export class DisclosureSymbol extends React.Component<DisclosureWithSymbolProps> {
  render() {
    const { className, symbol, disclosure, smallSymbol, id } = this.props;
    const cl = `${className || ''}${smallSymbol ? ' small' : ''}`;
    // Only add aria-describedby if `id` is not explicitly an empty string
    const ariaProps = id !== '' ? { 'aria-describedby': id || disclosure.id } : {};
    return (
      <sup
        {...(cl ? { className: cl.trim() } : {})}
        {...ariaProps}>
        {symbol || disclosure.symbol || ''}
      </sup>
    );
  }
}
type DisclosuresWrapperProps = {
  children: ReactNode | ReactNode[];
  className?: string;
  id?: string;
};
export class DisclosuresWrapper extends React.Component<DisclosuresWrapperProps> {
  render() {
    const { className = '', children, id } = this.props;

    const props = {
      role: 'note',
      className: `disclosures ${className}`.trim(),
      ...(id ? { id } : {})
    };

    return <aside {...props}>{children}</aside>;
  }
}
